import React from "react"
import { useLocation } from "@reach/router"
import { useSiteMetadata } from "@/hooks/use-site-metadata"

const BlogStructuredData = ({ post, imageUrl }) => {
  const { siteUrl } = useSiteMetadata()
  const { pathname } = useLocation()
  const isSanity = post.internal?.type === "SanityBlogPost"

  const headline = isSanity
    ? post.seo?.seoTitle || post.title
    : post.frontmatter.title
  const description = isSanity
    ? post.seo?.seoDescription || post.summary
    : post.frontmatter.description || post.frontmatter.summary
  const datePublished = isSanity ? post.publishedAt : post.frontmatter.date
  const authorName = isSanity ? post.author?.name : post.frontmatter.author

  if (!headline || !datePublished || !authorName) {
    return null
  }

  const image =
    imageUrl &&
    (imageUrl.startsWith("http") ? imageUrl : `${siteUrl}${imageUrl}`)

  const schema = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline,
    description,
    datePublished: new Date(datePublished).toISOString(),
    author: { "@type": "Person", name: authorName },
    publisher: { "@type": "Organization", name: "Capsule CRM", url: siteUrl },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `${siteUrl}${pathname}`,
    },
    ...(image && { image: [image] }),
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  )
}

export default BlogStructuredData
